import { Mesh, MeshBasicMaterial, SphereGeometry } from "three/webgpu";
import Experience from "../Experience";

const POOL_SIZE = 16;
const BULLET_SPEED = 90; // absolute world units/sec (forward)
const BULLET_RADIUS = 0.18;
const MUZZLE_Z = 3;
const MUZZLE_Y = 1;
// Cap range so a bullet fired on the current lane can't reach bombs spawned far
// ahead on a future (different) lane. Tuned to just past the next-segment band.
const MAX_Z = 65;

export default class Projectiles {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.input = this.experience.input;

    this.geometry = new SphereGeometry(BULLET_RADIUS, 10, 8);
    this.material = new MeshBasicMaterial({ color: 0xff8a3d });
    this.material.color.multiplyScalar(2.5);

    this.bullets = [];
    for (let i = 0; i < POOL_SIZE; i++) {
      const mesh = new Mesh(this.geometry, this.material);
      mesh.visible = false;
      this.scene.add(mesh);
      this.bullets.push({ mesh, alive: false, x: 0, z: 0, lane: 1 });
    }

    this.input.on("shoot", () => this.fire());
  }

  _audio() {
    return this.experience.audio;
  }

  reset() {
    for (const b of this.bullets) {
      b.alive = false;
      b.mesh.visible = false;
    }
  }

  fire() {
    const game = this.experience.world && this.experience.world.game;
    if (!game || !game.isPlaying()) return;
    const train = this.experience.world && this.experience.world.train;
    if (!train || !train.group) return;
    const free = this.bullets.find((b) => !b.alive);
    if (!free) return;
    free.lane = train.lane;
    free.x = train.group.position.x;
    free.z = MUZZLE_Z;
    free.alive = true;
    free.mesh.visible = true;
    free.mesh.position.set(free.x, MUZZLE_Y, free.z);
    const audio = this._audio();
    if (audio) audio.playShoot();
  }

  update(delta, scrollSpeed) {
    // In the anchored-train frame, world objects scroll at -scrollSpeed.
    // Bullet has absolute forward velocity BULLET_SPEED, so its relative velocity is (BULLET_SPEED - scrollSpeed).
    const relVel = BULLET_SPEED - scrollSpeed;
    const obstacles = this.experience.world && this.experience.world.obstacles;
    let hits = 0;

    for (const b of this.bullets) {
      if (!b.alive) continue;
      b.z += relVel * delta;
      b.mesh.position.z = b.z;

      if (obstacles && obstacles.tryHit(b.x, b.z, b.lane)) {
        b.alive = false;
        b.mesh.visible = false;
        hits++;
        const audio = this._audio();
        if (audio) audio.playBomb();
        continue;
      }

      if (b.z > MAX_Z) {
        b.alive = false;
        b.mesh.visible = false;
      }
    }
    return hits;
  }
}
